import md5 from 'js-md5'
const tokenKey = md5('cbgc_market_token_20201027');
const clockInTokenKey = md5('clockin_token_s2')
const userKey = md5('cbgc_market_user');
const sessionId = md5('session_id');
const anonoymousId = md5('anonoymous_id');

//token
export function getToken(tokenType) {
	let key = tokenType ? clockInTokenKey : tokenKey
	let info = JSON.parse(localStorage.getItem(key));
	let now = Date.now();
	// 计算过期时间，预留了 60*5=300秒 = 5分钟的机动时间
	// 后端返回的expires_in 为秒数，需要转换为毫秒
	if(info){
		let expire_time = parseInt(info.token_created_at) + ( (parseInt(info.expires_in) - 300) * 1000)
		if(now > expire_time){
			removeToken(tokenType)
			return null;
		}else {
			return info.access_token
		}
	}else {
		return null
	}
}
export function setToken(data,tokenType) {
		let key = tokenType ? clockInTokenKey : tokenKey
		data = {
			token_created_at: Date.now(),
			...data
		}
		return localStorage.setItem(key,JSON.stringify(data))
}
export function removeToken(tokenType) {
		let key = tokenType ? clockInTokenKey : tokenKey
		return localStorage.removeItem(key)
}

//userinfo
export function getUser() {
		return JSON.parse(localStorage.getItem(userKey))
}

export function setUser(user) {
		return localStorage.setItem(userKey,JSON.stringify(user))
}

export function removeUser() {
		return localStorage.removeItem(userKey)
}


//sessionid
export function getSessionId() {
		return sessionStorage.getItem(sessionId)
}
export function setSessionId(id) {
		return sessionStorage.setItem(sessionId,id)
}

//anonoymousid
export function getAnonoymousId() {
		return localStorage.getItem(anonoymousId)
}
export function setAnonoymousId(id) {
		return localStorage.setItem(anonoymousId,id)
}
